var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconConfirm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.18 32.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.65,.25c-.57-.42-1.27-.31-1.97,.39-2.4,2.44-4.93,4.77-7.14,7.38-3.84,4.54-7.48,9.25-11.2,13.89-.31,.38-.61,.76-1.02,1.28-.33-.67-.56-1.08-.75-1.5-1.22-2.69-2.42-5.38-3.64-8.06-.19-.43-.39-.88-.7-1.22-.59-.66-1.64-.66-2.28-.09-.66,.59-.76,1.61-.13,2.25,1.52,1.57,1.87,3.66,2.81,5.48-.09,.05-.18,.1-.27,.15-.34-.52-.66-1.05-1.03-1.55-1.11-1.53-2.2-3.09-3.38-4.57-.52-.65-1.27-.7-1.66-.28-.5,.53-.22,1.1,.04,1.6,.36,.69,.83,1.33,1.21,2.01,2.53,4.5,5.03,9.01,7.58,13.49,.76,1.33,1.71,1.47,2.83,.41,.91-.87,1.69-1.87,2.52-2.83,1.99-2.32,3.89-4.71,5.96-6.96,3.88-4.21,7.86-8.34,11.79-12.51,.57-.61,.65-1.33,.24-1.86-.4-.53-1.12-.69-1.86-.3-.55,.3-1.08,.68-1.51,1.13-.76,.8-1.41,1.7-2.17,2.5-2.46,2.6-4.95,5.17-7.43,7.75-.05,.05-.18,.03-.4,.06,.21-.31,.37-.56,.54-.8,2.84-4,6.02-7.72,9.53-11.16,1.27-1.25,2.47-2.6,3.6-3.98,.66-.81,.53-1.64-.1-2.1Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfirm);
export default __webpack_public_path__ + "static/media/icon-confirm.74fe98264639318c2cfef6c673df3a90.svg";
export { ForwardRef as ReactComponent };